import { render, staticRenderFns } from "./warn.vue?vue&type=template&id=1a055c1e&scoped=true&"
import script from "./warn.vue?vue&type=script&lang=js&"
export * from "./warn.vue?vue&type=script&lang=js&"
import style0 from "./warn.vue?vue&type=style&index=0&id=1a055c1e&prod&lang=less&"
import style1 from "./warn.vue?vue&type=style&index=1&id=1a055c1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a055c1e",
  null
  
)

export default component.exports